import { SearchStationDetailType } from '@/schemas/SearchStationDetailSchema';
import { UseFormReturn } from 'react-hook-form';

type Args = {
  formMethod: UseFormReturn<SearchStationDetailType>;
};

export const useLogic = ({ formMethod }: Args) => {
  const searchType = formMethod.watch('searchType');

  return {
    searchType,
  };
};
